export function findExternalDataItem(ExternalProductData, productCode) {
  if (ExternalProductData === null) return undefined;
  return ExternalProductData.data.allOuModuleType.edges.find((x) => x.node.CourseDetails.courseCode === productCode);
}
